import { IMainComponentEvent } from '../generated-types/main-component-event'
import { IPaginatedResult } from './paginated-result'
import { useGet } from './reactQuery'

const baseUrl = (mainComponentId: EntityId) => `main-component/${mainComponentId}/events`

export const mainComponentEventEndpoints = {
  getMainComponentEvents(mainComponentId: EntityId) {
    return `${baseUrl(mainComponentId)}`
  },
}

export const useGetMainComponentEvents = (mainComponentId: EntityId, page = 0, pageSize = 10) =>
  useGet<IPaginatedResult<IMainComponentEvent>>(mainComponentEventEndpoints.getMainComponentEvents(mainComponentId), {
    page,
    pageSize,
  })
